export const formConstants = {
    EMPTY_EMAIL_MESSAGE: 'Please enter email.',
    EMPTY_MSG: 'No results found',
    EMPTY_PASSWORD_MESSAGE: 'Password cannot be empty.',
    FILL_LAST_NAME: 'Please fill Last Name.',
    FILL_DOB: 'Please fill valid DOB.',
    FILL_MEMBER_ID: 'Please fill Member ID',
    SSN_COUNT_FOUR: 'SSN count should be 4.',
    EMPTY_TEMPLATE_NAME: 'Please enter template name.',
    EMPTY_SUBJECT: 'Please enter subject.',
    EMPTY_MESSAGE: 'Please enter message.',
    EMPTY_TEMPLATE_LIST: 'Please Create New Template !!'
};